import { httpClient } from "./httpClient";

const getAllMember = () => {
  return httpClient.get("dataMember");
};

export default {
  getAllMember,
};
